define('drops/payment/payment',[
    'jquery',
    'lq',
    'lq/drop'
], function ($, lq, Drop) {
    'use strict';

    function Payment(options) {
        var $elem =  $('<form method="post" action="https://secure.ogone.com/ncol/prod/orderstandard.asp" id="paymentform" name="paymentform"></form>');
        Drop.call(this, $($elem), options);
    };

    Drop.extend(Payment);

    Payment.typeName = 'Payment';

    // note: building and submitting the form after doing an aynchronous call to fetch the data is blocked by most browsers
    // so instead we prefetch the data and build the form on page load
    Payment.prototype.preRender = function () {
        var data = {
            actionId: this.parent.data.id,
            morphId: this.data.id,
            parameters: this.piping.parameters.getNonSystemParameters()
        };

        var self = this;

        this.piping.dispatcher.dispatch('Query/GetPaymentInfo', data)
            .done(function (result) {
                var form = $('#paymentform');
                $('<input type="hidden" id="PSPID" name="PSPID">').val(result["OGONE_PSPID"]).appendTo(form);
                $('<input type="hidden" id="ORDERID" name="ORDERID">').val(result["OGONE_ORDERID"]).appendTo(form);
                $('<input type="hidden" id="AMOUNT" name="AMOUNT">').val(result["OGONE_AMOUNT"]).appendTo(form);
                $('<input type="hidden" id="CURRENCY" name="CURRENCY">').val(result["OGONE_CURRENCY"]).appendTo(form);
                $('<input type="hidden" id="LANGUAGE" name="LANGUAGE">').val(result["OGONE_LANGUAGE"]).appendTo(form);

                var acceptUrl = location.protocol + "//" + location.host + lq.getTenantUrl('LicquidAction/AcceptPayment/') + self.data.id + '?ORDERID=' + result["OGONE_ORDERID"];
                $('<input type="hidden" id="ACCEPTURL" name="ACCEPTURL">').val(acceptUrl).appendTo(form);

                var cancelUrl = location.protocol + "//" + location.host + lq.getTenantUrl('LicquidAction/Get/') + self.data.cancelRedirect;
                $('<input type="hidden" id="DECLINEURL" name="DECLINEURL">').val(cancelUrl).appendTo(form);
                $('<input type="hidden" id="EXCEPTIONURL" name="EXCEPTIONURL">').val(cancelUrl).appendTo(form);
                $('<input type="hidden" id="CANCELURL" name="CANCELURL">').val(cancelUrl).appendTo(form);
            });
    };

    Payment.prototype.executePayment = function () {
        $('#paymentform').submit();
    };

    return Payment;
});
    
    





